// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"6233ee2d","48":"621d618f","165":"dad52985","190":"2aa8ad34","198":"546c8158","247":"d23920e2","251":"74b5eeea","252":"6d5a3aea","354":"3ff675f7","381":"ca59edb6","578":"0652c354","687":"6d571065","785":"a8b37b48","935":"fba58c52","977":"17fb5a9a"}[chunkId] + ".chunk.js";
};